module.exports = __webpack_public_path__ + "static/media/moreover.0717ac1f.svg";